module.exports = __webpack_public_path__ + "static/media/42-beach-luke-anna.4261db37.jpg";